import { BarChart3, Gauge, Zap, DollarSign } from 'lucide-react';

const features = [
  {
    icon: BarChart3,
    title: 'Benchmark Aggregation',
    description: 'Performance percentages are calculated by averaging results from multiple trusted benchmarking sources including gaming and synthetic tests.',
  },
  {
    icon: Gauge,
    title: 'Relative Performance',
    description: 'All GPUs are measured relative to the RTX 4090 (100%), making it easy to understand how cards compare at a glance.',
  },
  {
    icon: Zap,
    title: 'Real-World Testing',
    description: 'Rankings prioritize gaming performance in popular titles at various resolutions, not just synthetic benchmarks.',
  },
  {
    icon: DollarSign,
    title: 'MSRP & Value',
    description: 'We include manufacturer suggested retail prices to help you evaluate the best price-to-performance ratio.',
  },
];

export const MethodologySection = () => {
  return (
    <section id="methodology" className="py-16 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            How We Rank Graphics Cards
          </h2>
          <p className="text-muted-foreground">
            Our GPU comparison methodology combines multiple data sources to provide accurate, 
            real-world performance rankings you can trust.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div 
              key={feature.title} 
              className="p-6 rounded-xl bg-card border shadow-card card-hover animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
